module.exports = __webpack_public_path__ + "static/media/my-bg.37f24614.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/my-bg.png
// module id = 2023
// module chunks = 6